import React from 'react';
import ReactPaginate from "react-paginate";
import "../../assets/css/common/dynamicPagination.scss";

const DynamicPagination = ({itemsPerPage, totalItems, handlePaginateButtonClick, activePage}) => {

    const pageCount = Math.ceil(totalItems / itemsPerPage);

    const handlePageClick = ({selected}) => {
        handlePaginateButtonClick(selected + 1);
    };
    if (pageCount === 1) return null;
    return (
        <ReactPaginate
            forcePage={activePage - 1}
            marginPagesDisplayed={1}
            onPageChange={handlePageClick}
            pageRangeDisplayed={1}
            pageCount={pageCount}
            renderOnZeroPageCount={null}
            containerClassName='pagination'
            activeClassName='active'
            pageClassName="page-item"
            pageLinkClassName="page-link"
            breakLabel="..."
            nextLabel={<i className='fa fa-angle-right'></i>}
            previousLabel={<i className='fa fa-angle-left'></i>}
            previousClassName="page-item prev"
            previousLinkClassName="page-link"
            nextClassName="page-item next"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            disabledClassName="page-item disabled"
        />
    );
};

export default DynamicPagination;
